// -- basic library --
import React from 'react';
import BaseTable from 'shared/components/molecules/Table/BaseTable';
import {
  TableBodyClickType,
  TableBodyMultipleValueType,
  TableHeaderType,
} from 'shared/components/molecules/Table/type';

interface Params {
  bodies: TableNotificationType[];
  selected_bodies: TableNotificationType[];
  handleCheckClick: (datas: TableNotificationType[]) => void;
}

export interface TableNotificationType {
  id: string;
  show_date: TableBodyClickType;
  title: string;
  check: TableBodyMultipleValueType<string>;
}

// -- external functions --

// テーブルの列の情報まとめたデータ
const headers: TableHeaderType[] = [
  {
    id: 'show_date',
    label: '日付',
    sortable: true,
    search_props: {
      type: 'datetime',
    },
  },
  {
    id: 'title',
    label: 'タイトル',
    sortable: true,
    search_props: {
      type: 'name',
      default_display: true,
    },
  },
  {
    id: 'check',
    label: '既読 / 未読',
    sortable: true,
    search_props: {
      type: 'name',
    },
  },
];

// -- main component --
const NotificatinoTable: React.FC<Params> = (params) => {
  // -- render part --
  return (
    <BaseTable
      bodies={params.bodies}
      headers={headers}
      table_name='Notifications'
      selected_bodies={params.selected_bodies}
      handleCheckClick={params.handleCheckClick}
    />
  );
};

// -- styled components --

// -- finally export part --
export default NotificatinoTable;
